import { render, staticRenderFns } from "./NhQualityPage.vue?vue&type=template&id=687254bd"
import script from "./NhQualityPage.vue?vue&type=script&lang=js"
export * from "./NhQualityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports